import arrayLength from './arrayLength';
export default function arrayHasMembers(maybeArray) {
    return arrayLength(maybeArray) > 0;
}
